<template>
  <v-form @submit="onSubmit">
    <functionality-form :doc="doc" :tags="tags" />
    <v-btn class="mt-5 amber black--text" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import FunctionalityForm from "./FunctionalityForm";
const fb = require("@/firebaseConfig.js");

export default {
  name: "UserServiceEdit",
  components: {
    FunctionalityForm,
  },
  data() {
    return {
      doc: {},
    };
  },
  props: {
    id: String,
    tags: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    console.log("id", this.id);
    const ref = fb.functionalityBetaCollection.doc(this.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      const updateRef = fb.functionalityBetaCollection.doc(this.id);
      updateRef
        .set(this.doc)
        .then(() => {
          this.doc = {};
          this.$emit("complete", this.id);
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
  },
};
</script>
